const comments = [
  { name: '小雨', time: '3天前', rating: 5, text: '和老公一起看了《时空恋旅人》，两个人窝在沙发上哭得稀里哗啦。夫妻影院的推荐真的很懂我们，每一部都很对味。免费高清在线观看不缓冲这点太赞了！' },
  { name: '阿杰与阿琳', time: '1周前', rating: 5, text: '自从发现了夫妻影院，每周五都成了我们的电影之夜。从浪漫电影推荐到夫妻必看影视，平台的选片品味真的很棒，感觉感情都升温了不少。' },
  { name: '小鹿妈妈', time: '2周前', rating: 5, text: '带娃太累了，偶尔等孩子睡着两个人偷偷看一部二人世界电影，简直是疲惫生活中的解药。画面高清，加载很快，推荐给所有夫妻！' },
  { name: '北方的风', time: '3周前', rating: 4, text: '内容质量很高，华语和海外精选都很丰富。如果能有更多婚姻家庭题材的纪录片就更好了。总体来说是很棒的夫妻电影平台。' },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="mx-auto px-4 md:px-6 max-w-[1280px]">
        <div className="text-center mb-12">
          <span className="inline-block bg-secondary-100 text-secondary-700 text-xs font-semibold px-3 py-1 rounded-full mb-3 whitespace-nowrap">
            真情实感
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900">
            观众评论
          </h2>
          <p className="text-sm text-foreground-500 mt-3 max-w-xl mx-auto">
            来自真实夫妻和情侣的观影分享与温暖反馈
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {comments.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-100 border border-background-200/70 rounded-xl p-6 md:p-7"
            >
              <div className="flex items-center gap-1 mb-3">
                {Array.from({ length: 5 }).map((_, i) => (
                  <div key={i} className="w-4 h-4 flex items-center justify-center">
                    <i className={`text-sm ${i < item.rating ? 'text-accent-500 ri-star-fill' : 'text-foreground-200 ri-star-line'}`}></i>
                  </div>
                ))}
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                &ldquo;{item.text}&rdquo;
              </p>
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-2.5">
                  <div className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 text-sm font-bold">
                    {item.name.charAt(0)}
                  </div>
                  <span className="text-sm font-medium text-foreground-800">{item.name}</span>
                </div>
                <span className="text-xs text-foreground-400">{item.time}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}